import { styled } from '@mui/system';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/material';

export const TextareaAutosize = styled(BaseTextareaAutosize)(
  ({ theme }) => `
  box-sizing: border-box;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: var(--black);
  background: var(--white);
  border: 1px solid var(--color-outline);
  box-shadow: none;

  &:hover {
    border-color: var(--color-primary-500);
  }

  &:focus {
    border-color: var(--color-primary-500);
    box-shadow: none;
  }
  
  &[readonly] {
    border-color: var(--color-greyscale-100);
    background-color: var(--color-greyscale-50);
  }

  /* firefox */
  &:focus-visible {
    outline: 0;
  }
`,
);
